import { render, staticRenderFns } from "./PaymentGatewayCharge.vue?vue&type=template&id=2d440d04"
import script from "./PaymentGatewayCharge.vue?vue&type=script&lang=js"
export * from "./PaymentGatewayCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports